import {
  PersonInvolvementKindSchema,
  type PersonInvolvementKind,
} from "../types/involvement.js";
import { carriesViewUpByInvolvementKind } from "./carriesViewUpByInvolvementKind.js";

export const involvementKindsCarryingViewUp: readonly PersonInvolvementKind[] =
  PersonInvolvementKindSchema.options.filter(
    (kind) => carriesViewUpByInvolvementKind[kind],
  );
